export var DisciplineCategory;
(function (DisciplineCategory) {
    DisciplineCategory[DisciplineCategory["Single"] = 0] = "Single";
    DisciplineCategory[DisciplineCategory["Double"] = 1] = "Double";
    DisciplineCategory[DisciplineCategory["Mixed"] = 2] = "Mixed";
})(DisciplineCategory || (DisciplineCategory = {}));
export var DisciplineGender;
(function (DisciplineGender) {
    DisciplineGender[DisciplineGender["Men"] = 0] = "Men";
    DisciplineGender[DisciplineGender["Women"] = 1] = "Women";
    DisciplineGender[DisciplineGender["Mixed"] = 2] = "Mixed";
})(DisciplineGender || (DisciplineGender = {}));
export class Disciplines {
    static getShortName(longName) {
        return this.disciplineCodesMap[longName];
    }
    static getLongName(shortName) {
        return Object.keys(this.disciplineCodesMap).find(key => this.disciplineCodesMap[key] === shortName && key);
    }
    static getDisciplineCategoryFromCode(disciplineCode) {
        switch (disciplineCode) {
            case this.disciplineCodesMap.MixedDoubles:
            case this.disciplineCodesMap.Double:
                return DisciplineCategory.Mixed;
            case this.disciplineCodesMap.MensDoubles:
            case this.disciplineCodesMap.WomensDoubles:
                return DisciplineCategory.Double;
            case this.disciplineCodesMap.MensSingles:
            case this.disciplineCodesMap.WomensSingles:
            case this.disciplineCodesMap.Single:
                return DisciplineCategory.Single;
            default:
                return undefined;
        }
    }
    static getDisciplineGenderFromCode(disciplineCode) {
        switch (disciplineCode) {
            case this.disciplineCodesMap.MixedDoubles:
            case this.disciplineCodesMap.Double:
            case this.disciplineCodesMap.Single:
                return DisciplineGender.Mixed;
            case this.disciplineCodesMap.MensDoubles:
            case this.disciplineCodesMap.MensSingles:
                return DisciplineGender.Men;
            case this.disciplineCodesMap.WomensDoubles:
            case this.disciplineCodesMap.WomensSingles:
                return DisciplineGender.Women;
        }
    }
}
Disciplines.disciplineCodesMap = {
    MixedDoubles: "MD",
    WomensSingles: "DS",
    MensSingles: "HS",
    WomensDoubles: "DD",
    MensDoubles: "HD",
    Single: "S",
    Double: "D"
};
